export function currentDate() {
  const dt = new Date();
  return dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
}

export function nextDate() {
  const dt = new Date();
  dt.setDate(dt.getDate() + 1);
  const mDay = dt.getDate();
  const day = mDay < 10 ? `0${mDay}` : `${mDay}`;
  const mMonth = dt.getMonth() + 1;
  const month = mMonth < 10 ? `${mMonth}` : `${mMonth}`;
  const year = dt.getFullYear();
  return `${year}-${month}-${day}`;
}

export const months = [
  "Januari",
  "Februari",
  "Mac",
  "April",
  "Mei",
  "Jun",
  "Julai",
  "Ogos",
  "September",
  "Oktober",
  "November",
  "Disember",
];

export const monthsHalf = [
  "Jan",
  "Feb",
  "Mac",
  "Apr",
  "Mei",
  "Jun",
  "Jul",
  "Ogo",
  "Sep",
  "Okt",
  "Nov",
  "Dis",
];

export const monthsIslamic = [
  "Muharram",
  "Safar",
  "RabiulAwal",
  "RabiulAkhir",
  "JamadilAwal",
  "JamadilAkhir",
  "Rejab",
  "Syaaban",
  "Ramadan",
  "Syawal",
  "Zulkaedah",
  "Zulhijjah",
];

export function hour24(source) {
  const [time, modifier] = source.split(" ");
  let [hours, minutes] = time.split(":");
  minutes = parseInt(minutes);
  if (hours === "12") {
    hours = "00";
  }
  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  } else {
    hours = parseInt(hours);
  }
  const mHours = hours < 10 ? `0${hours}` : `${hours}`;
  const mMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  return `${mHours}:${mMinutes}`;
}

export function hour12(source) {
  let [hours, minutes] = source.split(":").map(Number);
  let period = hours >= 12 ? "PTG" : "PG";
  hours = hours % 12 || 12;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  return `${hours}:${minutes} ${period}`;
}

export function hour24Arr(source) {
  const [time, modifier] = source.split(" ");
  let [hours, minutes] = time.split(":");
  minutes = parseInt(minutes);
  if (hours === "12") {
    hours = "00";
  }
  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }
  return [hours, minutes];
}

export function convertDate(source) {
  const dt = new Date();
  var [year, month, day] = source.split("-");
  year = parseInt(year);
  month = parseInt(month);
  day = parseInt(day);
  dt.setFullYear(year, month - 1, day);
  const mDay = dt.getDate();
  const days = mDay < 10 ? `0${mDay}` : `${mDay}`;
  const mMonth = dt.getMonth();
  const months = monthsHalf[mMonth];
  const years = dt.getFullYear();
  return `${days} ${months} ${years}`;
}

export function staticLocation(query) {
  const arrKey = ["kuala-lumpur", "selangor", "putrajaya"];
  const arrZone = ["KUL01", "SEL01", "PUT01"];
  const arrLocation = [
    "01 Kuala Lumpur.",
    "01 Gombak, Petaling, Sepang, Hulu Selangor, Rawang & Shah Alam.",
    "02 Putrajaya.",
  ];
  const mQuery = query.toLowerCase();
  const found = arrKey.find((e) => e === mQuery);
  var zone = null;
  var location = null;
  if (found) {
    const index = arrKey.indexOf(found);
    if (index >= 0) {
      zone = arrZone[index];
      location = arrLocation[index];
    }
  }
  return { zone: zone, loc: location };
}
